export { default } from './SiteAwareHomeTitle';
